import { getDataQAForInput } from '__components/Inputs/helpers';
import Input from '__components/Kizen/Input';
import { StyledWizardField } from 'components/Wizards/shared/styles';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import WizardStateContext from 'components/Wizards/shared/context/wizardstate';
import { KizenTypography } from '__app/typography';

const Wrapper = StyledWizardField as any;

export const TooltipSettings = ({
  value = '',
  onChangeValue = () => null,
  compact = false,
  flex = false,
}) => {
  const { t } = useTranslation();

  const { entityName } = useContext(WizardStateContext.Context);

  return (
    <div>
      <Wrapper top={compact ? 0 : undefined} flex={flex}>
        <KizenTypography type="subheader">
          {t('{{entity}} Description', {
            entity: entityName,
          })}
        </KizenTypography>
        <Input
          placeholder={t('Enter an optional description for this {{entity}}', {
            entity: entityName?.toLowerCase(),
          })}
          value={value}
          onChange={onChangeValue}
          {...getDataQAForInput('dashlet-tooltip')}
        />
      </Wrapper>
    </div>
  );
};
